import Footer from "./Footer";
import Navbar from "./Navbar";

// ---------------- NEWS PAGE ----------------
export const News = () => (
<>
<Navbar />
<section className="px-6 py-28 bg-gray-100 text-center">
<h1 className="text-5xl font-bold">News & Updates</h1>
<p className="text-xl max-w-2xl mx-auto mt-4">Latest updates from ZajraGreen — new installations, product launches and industry insights.</p>
</section>


<section className="container mx-auto px-6 py-20 space-y-16">
<article>
<h2 className="text-3xl font-bold">New Cricket Arena Launched in Noida</h2>
<p className="mt-2">We recently completed a modern cricket arena with shockpad turf and premium nets.</p>
</article>


<article>
<h2 className="text-3xl font-bold">ZajraGreen Expands to Punjab</h2>
<p className="mt-2">Now delivering turf installation & maintenance in Chandigarh, Ludhiana and Amritsar.</p>
</article>
</section>
<Footer />
</>
);